export default [
    {
        path: '/admin/compensation-items',
        name: 'compensation-items',
        meta: { requiresAuth: true },
        component: () => import('@/pages/payroll/item-compensate/index.vue')
    }
]